import React from "react";
import { TableCell } from "@mui/material";

// Components
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { KOGTableRow } from "@/main/components/shared/boxGrid/styles";

// Utils & Models
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { formatCurrency } from "@/main/services/utilsNumber";
import { SupplierInventoryImportDataResponse } from "@/main/models/response";

// Styles
import * as S from "./styles";

interface Props {
	returnImport: SupplierInventoryImportDataResponse | null;
}

const ModalResultImport: React.FC<Props> = ({ returnImport }: Props) => {
	const LIMIT_PARTS_NOT_IMPORTED = 200;
	const rowsGroup = ["150px", "150px", "20%", "150px", "20%", "20%", "20%", "20%", "20%", "20%", "10%"];
	const rowHeaders = [
		getTranslateByKey("information.sku"),
		`${getTranslateByKey("quoteCard.partName")}
    (${getTranslateByKey("information.inpies")})`,
		getTranslateByKey("information.position"),
		`${getTranslateByKey("companyType.supplier")}
    ${getTranslateByKey("quoteCard.partName").toLowerCase()}`,
		getTranslateByKey("information.vehiclelist"),
		getTranslateByKey("information.partTypes"),
		getTranslateByKey("information.partBrand"),
		getTranslateByKey("importInventory.shippingPrice"),
		getTranslateByKey("importInventory.autoDeliveryPrice"),
		getTranslateByKey("information.amount"),
		getTranslateByKey("information.pickupDays"),
	];

	function renderPriceColumn(price: string) {
		if (price === "" || price.toLowerCase() === getTranslateByKey("importInventory.noPrice").toLowerCase()) {
			return getTranslateByKey("importInventory.noPrice");
		}

		return formatCurrency(Number(price));
	}

	if (isNullUndefined(returnImport)) {
		return <></>;
	}

	return (
		<S.BoxModal>
			<S.TitleModal>{`${getTranslateByKey("importInventory.import")}
          ${getTranslateByKey("information.summary").toLowerCase()}`}</S.TitleModal>
			<S.LabelModal>{`${getTranslateByKey("information.partsimported")}:
          ${returnImport.partsImported} ${getTranslateByKey("information.records")}`}</S.LabelModal>
			<S.LabelModal>{`${getTranslateByKey("information.partsnotimported")}:
          ${returnImport.partsNotImported} ${getTranslateByKey("information.records")}`}</S.LabelModal>
			{!isNullUndefined(returnImport.parts) && returnImport.parts.length > 0 && (
				<S.ContainerTitleGrid>
					<S.TitleGridModal>{getTranslateByKey("information.belowpartsnotimported")}</S.TitleGridModal>
					{returnImport.partsNotImported > LIMIT_PARTS_NOT_IMPORTED && (
						<S.LabelAlert>{getTranslateByKey("information.morepartsnotimportedcheck")}</S.LabelAlert>
					)}
				</S.ContainerTitleGrid>
			)}
			{!isNullUndefined(returnImport.parts) && returnImport.parts.length > 0 && (
				<BoxGrid rowHeaders={rowHeaders} maxHeight={"310px"} marginCustom=".5rem 0 0 0" sizeColumns={rowsGroup}>
					{returnImport.parts.map((part) => (
						<KOGTableRow key={part.sku} style={{ cursor: "auto" }}>
							<TableCell>
								<S.CustomColumn title={part.sku}>{part.sku}</S.CustomColumn>
							</TableCell>
							<TableCell>
								<S.CustomColumn title={part.partName}>{part.partName}</S.CustomColumn>
							</TableCell>
							<TableCell>
								<S.CustomColumn title={part.position}>{part.position}</S.CustomColumn>
							</TableCell>
							<TableCell>
								<S.CustomColumn title={part.supplierPartName}>{part.supplierPartName}</S.CustomColumn>
							</TableCell>
							<TableCell>
								<S.CustomColumn title={part.vehicle}>{part.vehicle}</S.CustomColumn>
							</TableCell>
							<TableCell>
								<S.CustomColumn title={part.partType}>{part.partType}</S.CustomColumn>
							</TableCell>
							<TableCell>
								<S.CustomColumn title={part.partBrand}>{part.partBrand}</S.CustomColumn>
							</TableCell>
							<TableCell>
								<S.CustomColumn title={renderPriceColumn(part.price)}>{renderPriceColumn(part.price)}</S.CustomColumn>
							</TableCell>
							<TableCell>
								<S.CustomColumn title={renderPriceColumn(part.shippingPrice)}>
									{renderPriceColumn(part.shippingPrice)}
								</S.CustomColumn>
							</TableCell>
							<TableCell>
								<S.CustomColumn title={part.amount}>{part.amount}</S.CustomColumn>
							</TableCell>
							<TableCell>
								<S.CustomColumn title={part.pickupDays}>{part.pickupDays}</S.CustomColumn>
							</TableCell>
						</KOGTableRow>
					))}
				</BoxGrid>
			)}
		</S.BoxModal>
	);
};

export default ModalResultImport;
